module.exports = __webpack_public_path__ + "img/kufri-ecru-icon.901af05.webp";